// Centralised external links. Override via REACT_APP_GOOGLE_REVIEW_URL in env.
// Default points to a Google Maps search; replace with the actual
// "https://search.google.com/local/writereview?placeid=..." once available.
export const GOOGLE_REVIEW_URL =
  process.env.REACT_APP_GOOGLE_REVIEW_URL ||
  "https://www.google.com/search?q=Saveurs+Normandes+Louviers&authuser=0#mpd=~/g/11x40_xl06";

export const GOOGLE_BUSINESS_NAME = "Saveurs Normandes — Louviers";
